import type { FilterKeys } from '@niarab2c/frontend-commons/src/types/hotels';
import { LongStayFilterKeys } from '../app/reducers/longStay';
export const FILTER_KEYS: Partial<Record<FilterKeys | LongStayFilterKeys, FilterKeys | LongStayFilterKeys>> = {
  cancelPolicy: 'cancelPolicy',
  paymentType: 'paymentType',
  //roomType: 'roomType',
  award: 'award',
  cityName: 'cityName',
  // name: 'name',
  // price: 'price',
  meal: 'meal',
  hotelAmenities: 'hotelAmenities',
  // hotelId: 'hotelId',
  rateType: 'rateType',
  breakfast: 'breakfast',
  // remuneration: 'remuneration',
  credentialType: 'credentialType',
  // rawDistance: 'rawDistance',
  // negotiatedRateFlags: 'negotiatedRateFlags',
  metasearchPercentDiscount: 'metasearchPercentDiscount',
  outputPaymentType: 'outputPaymentType',
  ratePlanIsPublic: 'ratePlanIsPublic',
  includeExtraOptions: 'includeExtraOptions',
  neighborhood: 'neighborhood',
  isDirectFromProperty: 'isDirectFromProperty',
  apartmentSize: 'apartmentSize',
  bedroomCount: 'bedroomCount'
};
export const FILTER_TITLES: Partial<Record<FilterKeys | LongStayFilterKeys, string>> = {
  cancelPolicy: "Condições de Cancelamento",
  paymentType: "Formas de pagamento",
  includeExtraOptions: "Faturamento de extras",
  //roomType: 'Quarto',
  award: "Número de Estrelas",
  cityName: "Cidade",
  // name: 'Nome do Hotel',
  // price: 'Seu Orçamento',
  meal: "Regime de Alimentação",
  hotelAmenities: "Amenidades do Hotel",
  metasearchPercentDiscount: "Percentual de desconto",
  credentialType: "Fornecedor",
  rateType: "Tipo de Tarifa",
  outputPaymentType: "Formas de Recebimento",
  ratePlanIsPublic: "Tipo de Acordo",
  neighborhood: "Bairro",
  isDirectFromProperty: "Tipo de Venda",
  apartmentSize: "Área",
  bedroomCount: "Quartos"
};
export const FILTER_ONLY_B2C: (FilterKeys | LongStayFilterKeys)[] = ['cancelPolicy', 'paymentType', 'award', 'cityName', 'neighborhood', 'meal', 'hotelAmenities', 'metasearchPercentDiscount', 'apartmentSize', 'bedroomCount'];
export const FILTER_ONLY_CLIENT_USER: (FilterKeys | LongStayFilterKeys)[] = ['cancelPolicy', 'paymentType', 'includeExtraOptions', 'award', 'cityName', 'meal', 'hotelAmenities', 'metasearchPercentDiscount', 'rateType', 'outputPaymentType', 'ratePlanIsPublic', 'neighborhood', 'isDirectFromProperty', 'apartmentSize', 'bedroomCount'];
export const FILTER_FOR_HOTEL: FilterKeys[] = ['cancelPolicy', 'paymentType', 'includeExtraOptions', 'meal', 'metasearchPercentDiscount', 'rateType', 'outputPaymentType', 'ratePlanIsPublic', 'isDirectFromProperty'];